<template>
  <v-sheet color="transparent" width="100%" class="institutional">
    <v-sheet
      color="transparent"
      width="100%"
      class="
        secondary--text
        text-h5 text-sm-h4 text-md-h3 text-lg-h2
        font-weight-bold
        text-center
        pt-6 pt-md-8 pt-lg-12
      "
    >
      <Title>{{ item.title }}</Title>
    </v-sheet>

    <Loading v-if="loading" />

    <div v-else>
      <v-container class="pt-8 pb-10 pt-lg-12 pb-lg-16">
        <v-row justify="center" v-if="item.title">
          <v-col cols="12" md="10" lg="8">
            <!-- <Title>{{ item.title }}</Title> -->

            <img
              :src="files + item.img.featured.path + '?resize=1&w=800'"
              :alt="item.title"
              v-if="item.img && item.img.featured"
              class="featured-img mt-4"
            />

            <div
              class="grey--text text--lighten-1 text-body-2 mt-10"
              v-html="item.text"
              v-if="item.text"
            ></div>

            <div class="mt-8" v-if="images.length > 1">
              <div class="institutional-img-title mb-4">Galeria</div>

              <LightGallery
                :images="images"
                :index="index"
                :disable-scroll="true"
                @close="index = null"
              />

              <div class="institutional-img-list">
                <div
                  class="institutional-img-item"
                  v-for="(img, i) in images"
                  :key="i"
                  @click="index = i"
                >
                  <img :src="img + '?resize=1&w=600'" />
                </div>
              </div>
            </div>
          </v-col>
        </v-row>
        <div v-else>
          <v-alert prominent class="primary white--text">
            <v-row align="center">
              <v-col class="grow">
                <v-icon class="primary--text text--darken-3 mb-1 mr-2">
                  fa fa-exclamation-circle
                </v-icon>

                Nenhum conteúdo adicionado até o momento.
              </v-col>

              <v-col class="shrink">
                <v-btn class="primary darken-3 white--text" to="/">
                  Página Inicial
                </v-btn>
              </v-col>
            </v-row>
          </v-alert>
        </div>
      </v-container>
    </div>
  </v-sheet>
</template>

<script>
import Loading from "../widgets/Loading.vue";
// import Title from "../widgets/Title.vue";
import { LightGallery } from "vue-light-gallery";
import Title from "../widgets/Title.vue";

const _config = {
  mod: "about",
};

export default {
  data: () => ({
    loading: true,
    index: null,
  }),
  computed: {
    item() {
      return this.$rest(_config.mod).item;
    },
    images() {
      return this.item.img.list.map(({ path }) => {
        return this.files + path;
      });
    },
  },
  mounted() {
    this.$rest(_config.mod)
      .get({
        save: (state, data) => (state.item = data),
      })
      .then(() => (this.loading = false));
  },
  components: {
    Loading,
    LightGallery,
    Title,
  },
};
</script>

<style scoped>
.institutional-title {
  font-size: 37px;
  line-height: 45px;
  text-align: center;
}

.institutional .featured-img {
  width: 100%;
}

.institutional .institutional-text {
  font-size: 16px;
  line-height: 24px;
}

.institutional-img-list {
  display: grid;
  grid-template-columns: 1fr 1fr 1fr 1fr;
  gap: 10px;
}

.institutional-img-item img {
  aspect-ratio: 16 / 10;
  cursor: pointer;
  object-fit: cover;
  -o-object-fit: cover;
  width: 100%;
}

.institutional-img-title {
  color: #231f20;
  font-size: 20px;
  font-weight: 500;
  line-height: 24px;
}

@media screen and (max-width: 960px) {
  .institutional-title {
    font-size: 22px;
    line-height: 30px;
  }

  .institutional .text {
    font-size: 13px;
    line-height: 20px;
  }

  .institutional-img-list {
    grid-template-columns: 1fr 1fr 1fr;
  }
}

@media screen and (max-width: 600px) {
  .institutional-img-list {
    grid-template-columns: 1fr 1fr;
  }
}
</style>
